<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div class="orderCenter">
    <a-spin :spinning="spinning">
      <Title title="申请保函" />
      <div class="div_sc">
        <img
          src="../../assets/image/applyStep.png"
          alt=""
        >
        <a-button
          @click="manual"
          class="btn btnsc"
          type="primary"
        >
          投保操作手册
        </a-button>
      </div>
      <div class="search">
        <a-input
          class="ipt"
          v-model="projectName"
          placeholder="输入项目名称搜索"
        />
        <a-input
          style="margin-left: 10px;"
          class="ipt"
          v-model="projectCode"
          placeholder="输入项目编号搜索"
        />
        <a-button
          class="btn btns"
          @click="getOrderInfos"
          type="primary"
        >
          查询
        </a-button>
        <a-button
          @click="rest"
          class="btn btn_a"
        >
          重置
        </a-button>
        <!-- <a-button class="btn btn_a">
        </a-button> -->
        <letterGuarantee class="Guaranteeflex1" />
      </div>
      <div class="container">
        <div />
        <div class="table">
          <a-table
            :columns="columns"
            :scroll="{ x:960, y: 640 }"
            :pagination="false"
            :data-source="data"
            bordered
          >
            <!-- <span slot="statusStr" slot-scope="state">{{ guaranteeStateList[String(state)].label }}</span>
            <span slot="createTimeStr" slot-scope="createTime">{{ dateFormat(createTime) }}</span> -->
            <span
              slot="action"
              slot-scope="space, text"
            >
              <a
                class="look_btn"
                v-if="$store.state.info.companyName"
                @click="Look(text)"
              >申请</a>
              <!-- <a class="look_btn" @click="downloadBh" v-if="text.state === '3'">下载保函</a>
              <a class="look_btn" @click="viewBh" v-if="text.state === '3'">预览保函</a> -->
            </span>
          </a-table>
        </div>
        <div class="page">
          <span class="text">总共 {{ total }} 条记录</span>
          <a-pagination
            v-model="page"
            :total="total"
            show-size-changer
            :page-size="size"
            @showSizeChange="onShowSizeChange"
            class="page_list"
          >
            <template
              slot="buildOptionText"
              slot-scope="props"
            >
              <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script>
import letterGuarantee from './letterGuarantee';
import Title from '@/components/Title/index.vue';
import api from './api';
import { dictDetail } from '@/api/performance.js';
import { dateFormat } from '@/utils/format.js';

const columns = [

  {
    title: '项目名称',
    dataIndex: 'projectName',
    width: 120,
    ellipsis: true,
    key: 'projectName',
  },
  {
    title: '项目编号',
    dataIndex: 'projectCode',
    width: 180,
    ellipsis: true,
    key: 'projectCode',
  },
  {
    title: '标段名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '标段编号',
    dataIndex: 'code',
    key: 'code',
  },
  {
    title: '开标时间',
    width: 120,
    dataIndex: 'bidOpenTime',
    key: 'bidOpenTime',
    align: 'center',
  },
  {
    title: '公告时间',
    width: 120,
    dataIndex: 'noticeSendTime',
    key: 'noticeSendTime',
    align: 'center',
  },
  {
    title: '保证金金额（元）',
    dataIndex: 'marginAmount',
    key: 'marginAmount',
    width: 150,
    scopedSlots: { customRender: 'marginAmount' },
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    width: 150,
    scopedSlots: { customRender: 'action' },
  },
];

const data = [];
export default {
  components: { Title, letterGuarantee },
  data() {
    return {
      dateFormat,
      data,
      columns,
      size: 10,
      page: 1,
      total: 0,
      pageSizeOptions: [ '1', '15', '20' ],
      projectName: '',
      projectCode: '',
      spinning: false,
      guaranteeStateList: [],
      projectNatureList: [],
      guaranteeAptitudeList: [],
      guaranteeAptitudeLevelList: [],
      backletterFormatList: [],
      guaranteeProductList: [],
      radioA: 'a',
      guaranteeVisible: false,
    };
  },
  watch: {
    size() {
      this.getOrderInfos();
    },
    page() {
      this.getOrderInfos();
    },
  },
  mounted() {
    this.getOrderInfos();
    this.getDictDetail();
  },
  methods: {
    getDictDetail() {
      dictDetail({ dictName: 'guaranteeState' }).then(res => {
        this.guaranteeStateList = res.data.data;
      });
      dictDetail({ dictName: 'projectNature' }).then(res => {
        this.projectNatureList = res.data.data;
      });
      dictDetail({ dictName: 'guaranteeAptitude' }).then(res => {
        this.guaranteeAptitudeList = res.data.data;
      });
      dictDetail({ dictName: 'guaranteeAptitudeLevel' }).then(res => {
        this.guaranteeAptitudeLevelList = res.data.data;
      });
      dictDetail({ dictName: 'backletterFormat' }).then(res => {
        this.backletterFormatList = res.data.data;
      });
      dictDetail({ dictName: 'guaranteeProduct' }).then(res => {
        this.guaranteeProductList = res.data.data;
      });
    },
    //
    getOrderInfos() {
      this.spinning = true;
      const params = {
        size: this.size,
        page: this.page,
      };
      if (this.projectName) {
        params.projectName = this.projectName;
      }
      if (this.projectCode) {
        params.projectCode = this.projectCode;
      }
      api.getOrderInfos(params).then(({ data: data }) => {
        this.data = data.data.content;
        this.total = data.data.totalElements;
        this.spinning = false;
        console.log(data);
      });
    },
    onShowSizeChange(current, pageSize) {
      this.size = pageSize;
    },
    Look(row) {
      // sessionStorage.setItem('row',JSON.stringify(row))
      // this.$router.push({ path: "/enterForm", query: { type: 'look' } });
      console.log(this.$store.state.info.companyName);
      if (!this.$store.state.info.companyName) {
        return false;
      }
      const params = {
        companyName: this.$store.state.info.companyName,
        creditCode: this.$store.state.info.creditCode,
        sectionId: row.id,
      };
      api.postInsureApply(params).then(({ data: data }) => {
        if (data.data && data.data.redirecturl) {
          window.open(data.data.redirecturl, '_blank');
        }
      });
    },
    rest() {
      this.projectName = '';
      this.projectCode = '';
      this.getOrderInfos();
    },
    downloadBh() {
      const a = document.createElement('a'); // 创建一个<a></a>标签
      a.href = '/static/downloadView.pdf'; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.download = '保函.pdf'; // 设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      a.style.display = 'none'; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
    },
    viewBh() {
      const pdfUrl = 'static/downloadView.pdf';
      window.open(pdfUrl);
    },
    manual() {
      // axios({
      //   method: 'get',
      //   responseType: 'blob',
      //   url: process.env.BASE_URL +'./金骊保电子保函平台投标保函操作手册.pdf' // 文件路径
      // }).then(res => {
      //   const url = window.URL.createObjectURL(new Blob([res.data]));
      //   const link = document.createElement('a');
      //   const fileName = res.config.url.split('./')[1]
      //   link.href = url;
      //   link.setAttribute('download', fileName); // 文件名
      //   document.body.appendChild(link);
      //   link.click();
      //   link.parentNode.removeChild(link);
      //   window.URL.revokeObjectURL(url);
      // }).catch(error=>{
      //   console.log(error)
      // })
      // alert(process.env.BASE_URL)
      console.log(process.env.BASE_URL);
      window.open(process.env.BASE_URL + './金骊保电子保函平台投标保函操作手册.pdf');
    },
  },
};
</script>

<style lang="less" scoped>
#Plate_title{
  border-bottom: 0;
}
.orderCenter {
  width: 100%;
  min-height: 940px;
  .search {
    display: flex;
    margin: 20px 0;
    .ipt {
      width: 300px;
      height: 32px;
    }
    .btn {
      width: 80px;
      height: 32px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
    }
    .btns {
      background: #0E52D4;
      border: none;
      margin-left: 15px;
      margin-right: 0;
    }
    .btn_a {
      border: 1px solid #0E52D4;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #0E52D4;
      margin-left: 10px;
      margin-right: 0;
    }
  }
  .table {
    ::v-deep.ant-table-thead > tr > th {
      font-size: 14px !important;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400 !important;
      color: #333333 !important;
      background: rgba(0, 92, 168, 0.05) !important;
    }
    .p_text {
      position: relative;
      .p_red {
        width: 6px;
        height: 6px;
        background: #0E52D4;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        left: -10px;
        top: 7px;
      }
      .p_blue {
        width: 6px;
        height: 6px;
        background: #bae7ff;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        left: -10px;
        top: 7px;
      }
      .p_or {
        width: 6px;
        height: 6px;
        background: #0E52D4;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        left: -10px;
        top: 7px;
      }
      .p_gree {
        background: #aff0b5;
        width: 6px;
        height: 6px;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        left: -10px;
        top: 7px;
      }
      .p_h {
        background: #e9e9e9;
        width: 6px;
        height: 6px;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        left: -10px;
        top: 7px;
      }
    }
  }

  ::v-deep .ant-tabs-bar {
    border-bottom: none !important;
  }
  ::v-deep .ant-tabs-tab {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  ::v-deep .ant-tabs-nav .ant-tabs-tab-active {
    font-size: 16px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #0E52D4;
  }
  ::v-deep .ant-tabs-ink-bar {
    background: #0E52D4;
  }
  ::v-deep .ant-tabs-nav .ant-tabs-tab {
    padding: 10px 12px 20px 12px;
    text-align: center;
  }
  ::v-deep .ant-tabs-bar {
    margin: 0 0 3px 0;
  }
  a {
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #0E52D4;
  }
  .page {
    margin-top: 20px;
    position: relative;
    // display: flex;
    .page_list {
      text-align: right;
    }
    .text {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 7px;
      left: 0;
    }
  }
}

::v-deep .ant-tabs-nav .ant-tabs-tab {
  margin: 0px 12px 0 0;
}
::v-deep .ant-btn {
  border-color: #0E52D4 !important;
}
.look_btn {
  margin-right: 10px;
}
.orderCenter .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
  background: #0E52D4;
  border-color: #0E52D4;
}
.orderCenter .ant-radio-group{
  margin-bottom: 20px;
}

.div_sc{
  font-weight: 500;
  color: #0E52D4;
  height: 32px;
  margin: 5px 0 16px 0;
}
.btnsc {
  background: #0E52D4;
  border: none;
  float: right;
}
.div_sc img{
  height: 26px;
  transform: translateY(3px);
}
.Guaranteeflex1 {
  width: 100px;
  line-height: 32px;
  height: 32px;
  display: inline-block;
  flex-direction: row-reverse;
  border: 1px solid #0E52D4;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #0E52D4;
  margin-left: 10px;
  text-align: center;
  border-radius: 4px;
}
</style>

